export function mergeGridItems(modules, details, decors) {
	return [
		...modules.map(m => ({ ...m, label: m.name, interactive: true,  type: 'module', key: m.code })),
		...details.map(d => ({ ...d, label: d.name, interactive: true,  type: 'detail', key: `detail-${d.id}` })),
		...decors.map(d  => ({ ...d,                interactive: false, type: 'decor',  key: `decor-${d.id}` })),
	].sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity));
}
